// Implements: F-VER-014, F-UIX-009
/**
 * `GET /mockups/{id}/versions/tree`: the nodes of a mockup, in no promised order, for the modules
 * that show a version's cost (`costs`, `backoffice`, mockup v3 P7), which may not import
 * `versions`. It reads exactly what `modules/versions/api/versionsApi.ts` reads (the route's
 * client in the screen-coverage manifest) under the same `versionTreeKey`, so the two share one
 * cached answer; a later change of the shared client into here is the manifest holder's.
 */

import type { VersionTreeNode, VersionTreeView } from "../../types/api";
import { API_BASE } from "./apiBase";
import { httpRequest } from "./httpClient";

export function versionTreePath(mockupId: string): string {
  return `${API_BASE}/mockups/${encodeURIComponent(mockupId)}/versions/tree`;
}

export async function fetchVersionNodes(mockupId: string): Promise<readonly VersionTreeNode[]> {
  const tree = await httpRequest<Partial<VersionTreeView>>(versionTreePath(mockupId));
  return tree?.nodes ?? [];
}
